import { Component } from "@angular/core"; import { Location, formatDate } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { EmployeEntite, enrichirRechercheEmploye } from 'src/app/entites/employe';
import { BaseComponent } from 'src/app/base/base-component';
import { ProfilService } from 'src/app/services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { CleValeur, CleValeurNumerique } from 'src/app/entites/cleValeur';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { EntretienPreventifEntite } from 'src/app/entites/mecanique/entretien-preventif';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { ERaisonBonTravail } from 'src/app/entites/enums/raison-bon-travail';
import { EtapeBonTravailEntite } from 'src/app/entites/mecanique/etape-bon-travail';
import { RequeteAjouterEtapesBonTravail } from 'src/app/services/requetes/requete-ajouter-etapes-bon-travail';
import { ETypeEtapeBonTravail } from 'src/app/entites/enums/type-etape-bon-travail';
import { EntretienCorrectifEntite } from 'src/app/entites/mecanique/entretien-correctif';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { ETypeBonTravail } from 'src/app/entites/enums/type-bon-travail';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { Emplacement } from 'src/app/entites/emplacement';
import { ItemService } from 'src/app/services/item-service';
import { RaisonBonTravailEntite } from 'src/app/entites/mecanique/raison-bon-travail';
import { ReleveHeureEntite } from 'src/app/entites/releve-heures';
import { ReleveKmEntite } from 'src/app/entites/releve-kms';

export interface ParametresAssignerEntretiens {
    itemId: number;
    itemNumero?: string;
    entretiensPreventifs?: EntretienPreventifEntite[];
    entretiensCorrectifs?: EntretienCorrectifEntite[];
    contreMaitreId?: number;
    employeId: number;
}

export interface ResultatAssignerEntretiens {
    employeId: number;
    date: Date;
}

@Component({
    templateUrl: './assigner-entretiens.component.html',
    styleUrls: ['./assigner-entretiens.component.scss'],
})
export class AssignerEntretiensComponent extends BaseComponent {

    donnees: ParametresAssignerEntretiens;

    typesBonTravail: CleValeurNumerique[];
    selectionTypeBonTravail: CleValeurNumerique;

    listeEmployes: EmployeEntite[] = [];
    raisons: RaisonBonTravailEntite[] = [];
    emplacements: Emplacement[];
    fournisseurs: Fournisseur[];

    bonTravail: BonTravailEntite;
    dernierBonTravailRecent: BonTravailEntite;
    creationEnCours: boolean = false;
    private readonly moisRecentsBonTravail = 3;

    types: CleValeur[];
    selectionType: CleValeur;

    bonsTravail: BonTravailEntite[];

    submitted: boolean;
    blocked: boolean = false;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute,
        routerService: Router,
        appMain: AppMainComponent, location: Location, 
        public sdb: DonneesBaseService,
        public bonTravailService: BonTravailService,
        public fournisseurService: FournisseurService,
        public itemService: ItemService,
        public ref: DynamicDialogRef,
        public messageService: MessageService,
        public config: DynamicDialogConfig) {
        super(sdb, profilService, route, routerService, appMain);
    }

    ngOnInit() {

        this.donnees = this.config.data;

        this.types = [
            { "cle": "E", "valeur": "Bon de travail existant" },
            { "cle": "N", "valeur": "Nouveau bon de travail" }
        ];
        this.selectionType = this.types[0];

        this.typesBonTravail = [
            { "cle": ETypeBonTravail.Interne, "valeur": "Interne" },
            { "cle": ETypeBonTravail.Externe, "valeur": "Externe" }
        ];
        this.selectionTypeBonTravail = this.typesBonTravail[0];

        this.raisons = this.sdb.RaisonsBonTravail();
        this.emplacements = this.sdb.Emplacements();
        this.listeEmployes = this.sdb.EmployesMecanique();
        this.listeEmployes.forEach(emp => enrichirRechercheEmploye(emp));

        const raisonDefaut = this.sdb.RaisonBonTravail(
            this.donnees.entretiensCorrectifs?.length
                ? ERaisonBonTravail.EntretienCorrectif
                : ERaisonBonTravail.EntretienPreventif);

        this.bonTravail = {
            bonTravailId: 0,
            dateTravail: new Date(),
            dateCreation: new Date(),
            item: { itemId: this.donnees.itemId, numero: this.donnees.itemNumero },
            raison: raisonDefaut,
            emplacement: this.emplacements.find(x => x.emplacementId == 10000)
        };

        if (this.donnees.contreMaitreId) {
            this.bonTravail.contreMaitre = this.listeEmployes.find(x => x.employeId == this.donnees.contreMaitreId);
        } else {
            this.bonTravail.contreMaitre = this.listeEmployes.find(x => x.employeId == this.donnees.employeId);
        }

        var p1 = new Promise<number | void>((resolve, reject) => {
            this.bonTravailService.ObtenirOuvertsParItem(this.donnees.itemId).then(x => {
                this.bonsTravail = x.valeur;
                this.bonsTravail?.forEach(bdt => {
                    enrichirRechercheEmploye(bdt.contreMaitre);
                    enrichirRechercheEmploye(bdt.mecanicien);
                });
                resolve();
            });
        });

        var p2 = new Promise<number | void>((resolve, reject) => {
            this.fournisseurService.ObtenirFournisseurs().then(x => {
                this.fournisseurs = x.valeur;

                resolve();
            });
        });

        var p3 = new Promise<number | void | void>((resolve, reject) => {
            if (this.donnees.itemId) {
                this.itemService.ObtenirItem(this.donnees.itemId).subscribe(item => {
                    const detail = item.value();
                    this.bonTravail.item = this.itemService.ItemVersItemMin(detail);
                    if (detail.emplacement) {
                        this.bonTravail.emplacement = this.emplacements.find(x => x.emplacementId == detail.emplacement.emplacementId);
                    }
                    if (!this.bonTravail.contreMaitre
                        && detail.departementMecanique?.contreMaitre) {
                        this.bonTravail.contreMaitre = this.listeEmployes.find(
                            x => x.employeId == detail.departementMecanique.contreMaitre.employeId);
                    }
                    this.chargerDernierBonTravailRecent(detail.itemId);
                    resolve();
                });
            } else {
                resolve();
            }
        });

        /* var p2 = new Promise<number>((resolve, reject) => {
            this.releveKmService.ObtenirListeParItem(this.itemId).then(x => {
                this.item.relevesKm = x.valeur;
                resolve();
            });
        });
 */

        Promise.all([p1, p2, p3]).then(x => {
            if (this.bonsTravail && this.bonsTravail.length == 0) {
                this.selectionType = this.types[1];

            }
            this.CompleterChargement();
        });
    }

    assigner() {

        this.submitted = true;
        this.messageService.clear();

        if (!this.valider()) {
            this.messageService.add({ key: 'assignerEntretien', severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }

        this.Bloquer();
        this.creationEnCours = true;

        this.bonTravail.type = this.selectionTypeBonTravail.cle;
        this.bonTravail.dateCreation = new Date();

        if (this.bonTravail.type == ETypeBonTravail.Interne) {
            if (this.bonTravail.mecanicien) {
                this.bonTravail.dateAssignation = new Date();
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnCours);
            } else {
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnAttente);
            }
        } else {
            if (this.bonTravail.fournisseur) {
                this.bonTravail.dateAssignation = new Date();
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnCours);
            } else {
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnAttente);
            }
        }

        this.bonTravailService.Creer(this.payloadCreation()).then(x => {
            if (x.estUnSucces) {

                var etapes: EtapeBonTravailEntite[] = [];

                var requete: RequeteAjouterEtapesBonTravail = {
                    bonTravailId: x.valeur.bonTravailId,
                    etapesPreventif: [],
                    etapesCorrectif: []
                }

                if (this.donnees.entretiensPreventifs?.length) {
                    this.donnees.entretiensPreventifs.forEach(ent => {
                        var etape: EtapeBonTravailEntite = {
                            etapeBonTravailId: 0,
                            entretienPreventif: ent,
                            categorie: ent.categorie,
                            description: ent.description,
                            indAFaire: true,
                            indComplete: false,
                            typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienPreventif)
                        }

                        requete.etapesPreventif.push(etape);
                    });
                } else {
                    this.donnees.entretiensCorrectifs.forEach(ent => {
                        var etape: EtapeBonTravailEntite = {
                            etapeBonTravailId: 0,
                            entretienCorrectif: ent,
                            categorie: ent.categorie,
                            description: ent.description,
                            note: ent.note,
                            indAFaire: true,
                            indComplete: false,
                            typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienCorrectif)
                        }

                        requete.etapesCorrectif.push(etape);
                    });
                }

               
                this.bonTravailService.AjouterEtapes(requete).then(resAjoutEtape => {
                    if (resAjoutEtape.estUnSucces) {

                        this.Debloquer();
                        this.creationEnCours = false;
                        this.ref.close(x.valeur);

                    } else {
                        resAjoutEtape.messages.forEach(x => {
                            this.messageService.add({ key: 'assignerEntretien', severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                        });
                        this.Debloquer();
                        this.creationEnCours = false;
                    }
                });


            } else {
                x.messages.forEach(x => {
                    this.messageService.add({ key: 'assignerEntretien', severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                });
                this.Debloquer();
                this.creationEnCours = false;
            }
        }).catch(() => {
            this.Debloquer();
            this.creationEnCours = false;
        });


    }


    /**
     * Valide le formulaire de nouveau BT (date, contre-maître, raison, unité).
     * Les heures et les KM ne sont pas bornés par le compteur courant.
     */
    valider() {
        return !!(this.bonTravail.dateTravail && this.bonTravail.contreMaitre && this.bonTravail.raison && this.bonTravail.item?.itemId);
    }

    /**
     * Mémorise le relevé d'heures de début sélectionné.
     */
    surReleveDebutHeureChange(releve: ReleveHeureEntite | null) {
        this.bonTravail.releveHeureDebut = releve ?? undefined;
        if (releve) {
            this.bonTravail.heuresDebutCompteur = releve.nbHeure;
        }
    }

    /**
     * Mémorise le relevé de KM de début sélectionné.
     */
    surReleveDebutKmChange(releve: ReleveKmEntite | null) {
        this.bonTravail.releveKmDebut = releve ?? undefined;
        if (releve) {
            this.bonTravail.kmDebutCompteur = releve.nbKm;
        }
    }

    /**
     * Charge le bon de travail le plus récent des derniers mois pour l'unité.
     */
    chargerDernierBonTravailRecent(itemId: number) {
        if (!itemId) {
            this.dernierBonTravailRecent = null;
            return;
        }

        this.bonTravailService.ObtenirParItem(itemId).then(x => {
            if (!x.estUnSucces || !x.valeur?.length) {
                this.dernierBonTravailRecent = null;
                return;
            }

            const dateLimite = new Date();
            dateLimite.setMonth(dateLimite.getMonth() - this.moisRecentsBonTravail);

            const bonsRecents = x.valeur
                .filter(bdt => !bdt.indSoumission)
                .filter(bdt => {
                    const dateReference = new Date(bdt.dateCreation || bdt.dateTravail);
                    return !isNaN(dateReference.getTime()) && dateReference >= dateLimite;
                })
                .sort((a, b) =>
                    new Date(b.dateCreation || b.dateTravail).getTime() -
                    new Date(a.dateCreation || a.dateTravail).getTime());

            this.dernierBonTravailRecent = bonsRecents[0] ?? null;
        });
    }

    /**
     * Texte d'avertissement lorsque l'unité possède déjà un BT récent.
     */
    get texteDernierBonTravailRecent(): string {
        const bonTravailRecent = this.dernierBonTravailRecent;
        if (!bonTravailRecent) {
            return '';
        }

        const numero = bonTravailRecent.numero || '---';
        const statut = bonTravailRecent.statut?.nom || '---';
        const date = this.formaterDateAffichage(bonTravailRecent.dateTravail || bonTravailRecent.dateCreation);

        return `Cette unité possède déjà un bon de travail récent (${numero}). Date : ${date} · Statut : ${statut}`;
    }

    /**
     * Formate une date en yyyy-MM-dd.
     */
    private formaterDateAffichage(date: Date | string | undefined): string {
        if (!date) {
            return '---';
        }

        const parsed = date instanceof Date ? date : new Date(date);
        if (isNaN(parsed.getTime())) {
            return '---';
        }

        return formatDate(parsed, 'yyyy-MM-dd', 'en-CA');
    }

    /**
     * Envoie seulement l'identifiant du relevé lié, sans le graphe imbriqué.
     */
    private payloadCreation(): BonTravailEntite {
        return {
            ...this.bonTravail,
            releveHeureDebut: this.bonTravail.releveHeureDebut?.releveHeureId
                ? { releveHeureId: this.bonTravail.releveHeureDebut.releveHeureId }
                : undefined,
            releveKmDebut: this.bonTravail.releveKmDebut?.releveKmId
                ? { releveKmId: this.bonTravail.releveKmDebut.releveKmId }
                : undefined
        };
    }

    annuler() {
        this.ref.close(null);
    }

    selectionnerBonTravail(bdt: BonTravailEntite) {
        this.submitted = true;
        this.messageService.clear();

        this.Bloquer();

        var etapes: EtapeBonTravailEntite[] = [];

        var requete: RequeteAjouterEtapesBonTravail = {
            bonTravailId: bdt.bonTravailId,
            etapesPreventif: [],
            etapesCorrectif: []
        }

        if (this.donnees.entretiensPreventifs?.length) {
            this.donnees.entretiensPreventifs.forEach(ent => {
                var etape: EtapeBonTravailEntite = {
                    etapeBonTravailId: 0,
                    entretienPreventif: ent,
                    categorie: ent.categorie,
                    description: ent.description,
                    indAFaire: true,
                    indComplete: false,
                    typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienPreventif)
                }

                requete.etapesPreventif.push(etape);
            });
        } else {
            this.donnees.entretiensCorrectifs.forEach(ent => {
                var etape: EtapeBonTravailEntite = {
                    etapeBonTravailId: 0,
                    entretienCorrectif: ent,
                    categorie: ent.categorie,
                    description: ent.description,
                    note: ent.note,
                    indAFaire: true,
                    indComplete: false,
                    typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienCorrectif)
                }
    
                requete.etapesCorrectif.push(etape);
            });
        }

        

        this.bonTravailService.AjouterEtapes(requete).then(resAjoutEtape => {
            if (resAjoutEtape.estUnSucces) {

                this.Debloquer();
                this.ref.close(bdt);

            } else {
                resAjoutEtape.messages.forEach(x => {
                    this.messageService.add({ key: 'assignerEntretien', severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                });
                this.Debloquer();
            }
        });
    }
}